// extracted by mini-css-extract-plugin
export default {"items":"BestItem_items__GYYfN","title":"BestItem_title__L-i0E","bestItems":"BestItem_bestItems__3IFVW"};